<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'MasterData',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-database-2-line',
  color: 'error',
  title: 'Master Data',
  description: 'Mengelola 12 entity data referensi (Unit, Pegawai, Vendor, dst.).',
  purpose: 'Panduan mengelola data referensi dasar yang dipakai hampir seluruh modul QUALIVA — lihat juga halaman Onboarding untuk urutan pengisian yang benar.',
  concept: [
    {
      icon: 'ri-list-check-3',
      title: '12 Jenis Data Referensi',
      text: 'Unit, Jabatan, Pegawai, Vendor, Kontrak, Alat Kesehatan, Fasilitas, dan 5 jenis Kategori (Dokumen/Checklist/Assessment/Indikator, plus Jenis Insiden) — semuanya dikelola dengan cara yang sama di sini.',
    },
    {
      icon: 'ri-error-warning-line',
      title: 'Urutan Pengisian Penting',
      text: 'Unit harus diisi sebelum Pegawai, dan Jabatan harus diisi sebelum Pegawai — lihat halaman Onboarding untuk penjelasan lengkap kenapa urutan ini wajib.',
    },
  ],
  steps: [
    { title: 'Buka menu Master Data, pilih jenis data yang ingin dikelola', detail: 'Mis. "Unit / Organisasi" atau "Pegawai".' },
    { title: 'Klik "+ Tambah" untuk menambah data baru', detail: 'Isi field sesuai jenis data — beberapa field butuh memilih data lain lebih dulu (mis. Pegawai butuh Unit & Jabatan).' },
    { title: 'Klik ikon pensil untuk mengedit, ikon sampah untuk menghapus', detail: 'Data yang sudah dipakai referensi di modul lain tidak akan hilang permanen saat dihapus — hanya disembunyikan dari daftar aktif.' },
  ],
  tips: [
    'Ikuti urutan di halaman Onboarding kalau ini instalasi baru — jangan langsung isi Pegawai sebelum Unit dan Jabatan ada.',
  ],
  faq: [
    { q: 'Kenapa dropdown Jabatan kosong saat saya membuat Pegawai baru?', a: 'Anda perlu mengisi Master Data Jabatan terlebih dulu. Lihat halaman Onboarding untuk urutan lengkapnya.' },
    { q: 'Apakah menghapus Unit yang sudah dipakai Pegawai akan menghapus data pegawainya juga?', a: 'Tidak — data yang sudah dipakai referensi tidak pernah dihapus permanen dari sistem, cuma tidak lagi bisa dipilih untuk data baru.' },
  ],
  related: [
    { title: 'Onboarding & Urutan Setup Awal', sub: 'Urutan wajib pengisian Master Data', icon: 'ri-flag-line', color: 'primary', to: { name: 'help-onboarding' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
